// @flow
import { useContext } from 'react';

import { IS_GD_IMPORTED_BACKEND_NAME } from '../components/renewal-automation/constants';
import { GD_IS_ADMIN_EDITED_BACKEND_NAME, GD_IS_SYSTEM_GENERATED_BACKEND_NAME } from '../constants';
import { EstimateContext } from '../contexts/EstimateContext';

export const getIfGlobalDiscountIsImported = (estimate) => {
  const { metrics_discount: estimateCustomDiscounts } = estimate;
  return estimateCustomDiscounts?.[IS_GD_IMPORTED_BACKEND_NAME] === true;
};

export const useGlobalDiscountProvidedByStatus = () => {
  const estimate = useContext(EstimateContext);
  const { inputs: estimateInputs } = estimate;

  const isGlobalDiscountAdminEdited = estimateInputs?.[GD_IS_ADMIN_EDITED_BACKEND_NAME];
  const isGlobalDiscountImported = getIfGlobalDiscountIsImported(estimate);
  const isGlobalDiscountSystemGenerated =
    estimateInputs?.[GD_IS_SYSTEM_GENERATED_BACKEND_NAME] === true;
  const isGlobalDiscountGivenByAdminUser = isGlobalDiscountAdminEdited === true;

  // Hide tag when is_admin_edited is null
  const shouldShowGDTag =
    isGlobalDiscountImported ||
    isGlobalDiscountSystemGenerated ||
    isGlobalDiscountAdminEdited != null;

  return {
    isGlobalDiscountImported,
    isGlobalDiscountSystemGenerated,
    isGlobalDiscountGivenByAdminUser,
    shouldShowGDTag,
  };
};
